export default "__VITE_ASSET__180f525b__"